/**
 * 车站信息
 * @author xingzb
 * @date 2020-3-16
 */

import request from '@/utils/request'
export function station(query) {
  return request({
    url: '/ntocc-basic-api/station',
    method: 'get',
    params: query
  })
}

export function delStation(query) {
  return request({
    url: '/ntocc-basic-api/station',
    method: 'delete',
    params: query
  })
}

export function addStation(query) {
  return request({
    url: '/ntocc-basic-api/station',
    method: 'post',
    params: query
  })
}

export function stationCode(code) {
  return request({
    url: `/ntocc-basic-api/station/${code}`,
    method: 'get'
  })
}

export function updateStation(query) {
  return request({
    url: '/ntocc-basic-api/station',
    method: 'put',
    params: query
  })
}

//扣费记录
export function jinchangchargeaccount(query) {
  return request({
    url: '/ntocc-basic-api/jinchangcharge/account',
    method: 'put',
    params: query
  })
}

//扣费记录
export function jcorderDetailList(query) {
  return request({
    url: '/ntocc-basic-api/jinchangcharge/orderDetailList',
    method: 'get',
    params: query
  })
}
